import type { IColumn } from 'shared/ui/TableNew'
import { secondsToTime } from 'shared/lib/secondsToTime'
import type { RowCallsComparison } from 'entities/Analytics/model/Table/RowCallsComparison'
import { type SearchTypesEnum } from 'widgets/SearchDropdown'
import { getBreakdownColumnName } from 'pages/analytics/lib'
import { AnalyticMetricCell, BreakdownEntityCell } from 'pages/analytics/ui'

export const getColumns = (filterType: SearchTypesEnum | null): IColumn<RowCallsComparison>[] => [
  {
    field: 'name',
    name: getBreakdownColumnName(filterType),
    fullName: getBreakdownColumnName(filterType),
    isDisabledChangeVisible: true,
    renderRowCell: (row) => {
      const { name, breakdownEntity } = row.fields

      return (
        <BreakdownEntityCell
          filterType={filterType}
          breakdownEntity={breakdownEntity}
          fallbackName={name}
        />
      )
    },
  },
  {
    field: 'outbound_calls',
    name: 'Outbound calls',
    renderRowCell: (row) => {
      const { outbound_calls } = row.fields

      return <AnalyticMetricCell value={outbound_calls} />
    },
  },
  {
    field: 'answered_outbound',
    name: 'Answered Outbound',
    renderRowCell: (row) => {
      const { answered_outbound } = row.fields

      return <AnalyticMetricCell value={answered_outbound} />
    },
  },
  {
    field: 'unanswered_outbound',
    name: 'Unanswered',
    renderRowCell: (row) => {
      const { unanswered_outbound } = row.fields

      return <AnalyticMetricCell value={unanswered_outbound} />
    },
  },
  {
    field: 'failed_outbound',
    name: 'Failed Outbound',
    renderRowCell: (row) => {
      const { failed_outbound } = row.fields

      return <AnalyticMetricCell value={failed_outbound} />
    },
  },
  {
    field: 'busy_outbound',
    name: 'Busy Outbound',
    renderRowCell: (row) => {
      const { busy_outbound } = row.fields

      return <AnalyticMetricCell value={busy_outbound} />
    },
  },
  {
    field: 'avg_duration_outbound',
    name: 'Average Duration Outbound',
    renderRowCell: (row) => {
      const { avg_duration_outbound } = row.fields

      return <>{secondsToTime((avg_duration_outbound ?? 0) * 60)}</>
    },
  },
  {
    field: 'inbound_calls',
    name: 'Inbound calls',
    renderRowCell: (row) => {
      const { inbound_calls } = row.fields

      return <AnalyticMetricCell value={inbound_calls} />
    },
  },
  {
    field: 'answered_inbound_human',
    name: 'Answered inbound by human',
    renderRowCell: (row) => {
      const { answered_inbound_human } = row.fields

      return <AnalyticMetricCell value={answered_inbound_human} />
    },
  },
  {
    field: 'answered_inbound_ai',
    name: 'Answered inbound by AI',
    renderRowCell: (row) => {
      const { answered_inbound_ai } = row.fields

      return <AnalyticMetricCell value={answered_inbound_ai} />
    },
  },
  {
    field: 'missed_inbound',
    name: 'Missed',
    renderRowCell: (row) => {
      const { missed_inbound } = row.fields

      return <AnalyticMetricCell value={missed_inbound} />
    },
  },
  {
    field: 'failed_inbound',
    name: 'Failed Inbound',
    renderRowCell: (row) => {
      const { failed_inbound } = row.fields

      return <AnalyticMetricCell value={failed_inbound} />
    },
  },
  {
    field: 'busy_inbound',
    name: 'Busy Inbound',
    renderRowCell: (row) => {
      const { busy_inbound } = row.fields

      return <AnalyticMetricCell value={busy_inbound} />
    },
  },
  {
    field: 'forwarded',
    name: 'Forwarded',
    renderRowCell: (row) => {
      const { forwarded } = row.fields

      return <AnalyticMetricCell value={forwarded} />
    },
  },
  {
    field: 'avg_duration_inbound',
    name: 'Average Duration Inbound',
    renderRowCell: (row) => {
      const { avg_duration_inbound } = row.fields

      return <>{secondsToTime((avg_duration_inbound ?? 0) * 60)}</>
    },
  },
]
